<article class="preview-card" [attr.data-template]="definition.template">
  @if (iconSvg && definition.template !== 'number') { <app-dashboard-icon [svg]="iconSvg" class="mb-1"></app-dashboard-icon> }
  @switch (definition.template) {
    @case ('number') {
      <div class="preview-number">
        <span class="preview-avatar"><app-dashboard-icon [svg]="iconSvg"><svg viewBox="0 0 24 24"><path d="M4 19V9l5 4 5-8 6 4" /></svg></app-dashboard-icon></span>
        <div><strong>{{ value }}</strong><span>{{ subtext }}</span></div>
      </div>
    }
    @case ('percentage') {
      <div class="preview-heading"><span>{{ definition.name }}</span><small>Last 30 days</small></div>
      <strong class="preview-value">{{ value }}</strong>
      <div class="progress progress-sm"><div class="progress-bar" [style.width]="value"></div></div>
    }
    @case ('graph') {
      <div class="preview-heading"><span>{{ definition.name }}</span><small>Last 30 days</small></div>
      <strong class="preview-value">{{ value }}</strong>
      <svg class="preview-chart" viewBox="0 0 100 40" preserveAspectRatio="none" aria-hidden="true">
        <polygon [attr.points]="'0,40 ' + chartPoints + ' 100,40'" />
        <polyline [attr.points]="chartPoints" />
      </svg>
    }
    @case ('sankey') {
      <div class="preview-heading"><strong>{{ definition.name }}</strong><small>Cash flow</small></div>
      <svg class="preview-chart" viewBox="0 0 100 40" preserveAspectRatio="none" aria-hidden="true">
        <path d="M8 4 C40 4 56 6 92 6 L92 17 C56 17 40 13 8 13 Z" fill="#2fb344" opacity=".5" />
        <path d="M8 16 C40 16 56 23 92 23 L92 31 C56 31 40 24 8 24 Z" fill="#206bc4" opacity=".5" />
        <rect x="5" y="4" width="3" height="20" fill="#206bc4" />
        <rect x="92" y="6" width="3" height="25" fill="#2fb344" />
      </svg>
    }
    @case ('welcome') {
      <div class="preview-heading"><strong>{{ data['title'] }}</strong><small>Business snapshot</small></div>
      @for (metric of metrics; track $index) {
        <div class="preview-metric"><span>Metric {{ $index + 1 }}</span><strong>{{ metric }}</strong></div>
      }
    }
    @case ('position') {
      <div class="preview-heading"><strong>{{ definition.name }}</strong><small>Posted balances</small></div>
      <div class="preview-row"><span>Account</span><strong>{{ value }}</strong></div>
    }
    @case ('list') {
      <div class="preview-heading"><strong>{{ definition.name }}</strong><small>Live list</small></div>
      @for (row of rows; track $index) {
        <div class="preview-row">@for (cell of rowValues(row); track $index) { <span>{{ cell }}</span> }</div>
      }
    }
    @case ('report') {
      <div class="preview-heading"><strong>{{ definition.name }}</strong><span class="badge bg-primary-lt">Report</span></div>
      <strong class="preview-value">{{ value }}</strong>
      <svg class="preview-chart" viewBox="0 0 100 40" preserveAspectRatio="none" aria-hidden="true">
        <polygon [attr.points]="'0,40 ' + chartPoints + ' 100,40'" />
        <polyline [attr.points]="chartPoints" />
      </svg>
    }
  }
</article>
